import { Unread } from "@/Contexts/ChatProvider";
import { createContext } from "react";

export const initialChatContext = {
    isReady: false,
    unread: {} as Unread,
};

export const ChatContext = createContext(initialChatContext);
